import fetch from '@/api/fetch'
import { deepClone } from '@/utils/common';


export default {
  state: {
    isGetMenu: false, // 是否已获得菜单
    menus: [],  // 菜单
    routes: [],  // 路由
    powers: [], // 权限列表
    powersObj: {}, // 权限对象，以id为键
    orgPowers: [], // 权限列表(单位管理员)
    orgPowersObj: {}, // 权限对象(单位管理员)，以id为键
  },
  getters: {
    menus: state => state.menus,
    routes: state => state.routes,
    powers: state => state.powers,
    powersObj: state => state.powersObj,
    orgPowers: state => state.orgPowers,
    orgPowersObj: state => state.orgPowersObj,
    isGetMenu: state => state.isGetMenu
  },
  mutations: {
    isGetMenuTrue: state => state.isGetMenu = true,
    isGetMenuFalse: state => state.isGetMenu = false,
    setMenus: (state, menus) => state.menus = menus,
    setRoutes: (state, routes) => state.routes = routes,
    setPowers: (state, powers) => state.powers = powers,
    setPowersObj: (state, powersObj) => state.powersObj = powersObj, 
    setOrgPowers: (state, orgPowers) => {
      state.orgPowers = orgPowers;
      let orgPowersObj = {};
      orgPowers.forEach(p => orgPowersObj[p.id] = p);
      state.orgPowersObj = orgPowersObj;
    },   
    removeMenu: (state) => {
      state.isGetMenu = false;
      state.menus = [];
      state.routes = [];
      state.powers = [];
      state.powersObj = {};
      state.orgPowers = [];
      state.orgPowersObj = {};
    },
    removeAllNotRoutes: state => {
      state.isGetMenu = false;
      state.menus = [];
      state.powers = [];
      state.powersObj = {};
      state.orgPowers = [];
      state.orgPowersObj = {};
    }
  },
  actions: {
    getMenu: context => context.commit('isGetMenuTrue'),
    removeMenu: context => context.commit('removeMenu'),
    checkMenu: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        if (getters.isGetMenu) {
          resolve(getters.routes)
          return;
        }
        fetch.get('/index/power/pc').then(result => {
          let data = result.data.data;
          let powers = data.sys;
          if (!powers || !powers.length) {
            powers = data.org;
            if (powers && powers.length) {
              commit('setOrgPowers', powers);
            } else {
              powers = [];
            }

            if (data.pro && data.pro.length) {
              powers = powers.concat(data.pro);
            }
          }

          powers = powersDuplicateRemoval(powers);
          let res = compute(powers);
          
          commit('setMenus', res.menus);
          commit('setRoutes', res.routes);
          commit('setPowers', powers);
          let powersObj = {};
          powers.forEach(p => powersObj[p.id] = p);
          commit('setPowersObj', powersObj);
          resolve(res.routes);
        }).catch(err => {
          resolve([]);
        })
      })
    }
  }
}

function powersDuplicateRemoval(powers) { // 权限列表去重
  let tempObj = {};
  let ret = [];
  powers.forEach(power => {
    if (tempObj[power.id]) {
      return;
    }
    tempObj[power.id] = true;
    ret.push(power);
  });
  return ret;
}

function compute(data) {
  let menus = [];
  let routes = [];

  let menuObj = {};
  let routesObj = {};
  data.forEach(m => {
    menuObj[m.id] = {
      name: m.name,
      path: m.url,
      icon: m.icon,
      pId: m.pId,
      id: m.id
    };
    routesObj[m.id] = {
      name: m.name,
      path: m.url,
      icon: m.icon,
      pId: m.pId,
      id: m.id,
      component: () => import('@/views/' + m.component)
    };

    if (!m.pId) {
      if (m.typeCode == 1) {
        menus.push(menuObj[m.id]);
        routes.push(routesObj[m.id]);
      } else if (m.typeCode == 2) {
        routes.push(routesObj[m.id]);
      }
    }
  });

  for (let m of data) {
    if (!m.pId) {
      continue;
    }
    if (menuObj[m.pId]) {
      let parent = menuObj[m.pId];
      if (parent) {
        if (m.typeCode == 1) {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push(menuObj[m.id]);
          routeItemPushToParent(routesObj, m);
        } else if (m.typeCode == 2) {
          if (!parent.children) {
            parent.children = [];
          }
          routeItemPushToParent(routesObj, m);
        }
      }
    } else if (routesObj[m.pId]) {
      routeItemPushToParent(routesObj, m);
    }
  };

  setMenuPath(menus);
  setRoutes(routes);

  return { menus, routes }
}

function routeItemPushToParent(routesObj, item) {
  let parent = routesObj[item.pId];
  while (parent && parent.pId) {
    parent = routesObj[parent.pId];
  }
  if (!parent.children || parent.children.length == 0) {
    parent.children = [];
  }
  parent.children.push(routesObj[item.id]);
}

function setMenuPath(menus) {
  for (let menu of menus) {
    if (menu.children && menu.children.length) {
      setMenuPath(menu.children);
      menu.path = menu.children[0].path;
    } else if (!menu.children || !menu.children.length) {
      menu.children = undefined;
    }
  }
}

function setRoutes(routes) {
  routes.forEach(r => {
    if (!r.children || !r.children.length) {
      r.children = [deepClone(r)]
      r.component = () => import('@/views/Home');
    }
  })
}
